<div class="modal-header">
  <button
    (click)="dismiss()"
    aria-label="Close"
    class="close"
    type="button"
  ></button>
</div>
<div
  *ngIf="Error.error.status === 400"
  aria-label="When HttpError Status code is 400"
  class="my-7 px-4"
  role="main"
>
  <div class="text-center">
    <p class="errors" xmlns:svg="http://www.w3.org/2000/svg">
      <svg:svg
        aria-hidden="true"
        height="136"
        viewBox="0 0 141 136"
        width="141"
        xmlns="http://www.w3.org/2000/svg"
      >
        <svg:g
          fill="none"
          fill-rule="evenodd"
          stroke-width="3"
          transform="translate(2 2)"
        >
          <svg:g class="icon-stroke" stroke-linecap="round">
            <svg:path
              d="M0 68.4063448C0 30.6270345 30.6270345 0 68.4063448 0 80.6732414 0 92.186069 3.22868966 102.142207 8.88344828M43.1533793 132C28.5256552 126.185931 16.3786207 115.471172 8.7377931 101.884276M136.81269 68.4063448C136.81269 97.2066207 119.013931 121.849655 93.8171034 131.937793"
            />
            <svg:path
              d="M42.2961379 20.1307586C50.1281379 15.8536552 59.1117241 13.4215172 68.6642759 13.4215172 90.86 13.4215172 109.989379 26.5471724 118.715034 45.4595862M122.045379 82.185931C115.964276 105.997517 94.3708966 123.603586 68.6642759 123.603586 38.2390345 123.603586 13.5732414 98.9393103 13.5732414 68.5125517"
            />
          </svg:g>
          <svg:g class="icon-stroke" transform="translate(35 32)">
            <svg:path
              d="M47.2484138,33.389931 L65.2626207,51.4041379 C69.3424828,55.484 69.3424828,62.0961379 65.2626207,66.176 L65.2626207,66.176 C61.1827586,70.2558621 54.5706207,70.2558621 50.4907586,66.176 L33.2533793,48.9386207"
            />
            <svg:polyline
              points="30.692 26.682 20.946 16.935 20.92 11.388 10.474 .942 .029 11.388 10.474 21.833 16.021 21.859 25.552 31.39"
              stroke-linejoin="round"
            />
            <svg:path
              d="M46.4852414,47.3986207 L56.3336552,57.2470345"
              stroke-linecap="round"
            />
          </svg:g>
          <svg:g
            class="icon-stroke"
            stroke-linecap="round"
            stroke-linejoin="round"
            transform="translate(33 30)"
          >
            <svg:path
              d="M39.5973,45.7504 C41.1023,44.2404 42.6203,42.7434 44.1203,41.2274 C47.1593,38.1544 48.0683,37.1064 50.0053,35.8374 C50.9053,35.2484 51.8113,34.7534 52.9793,34.4124 C54.4763,33.9774 55.7843,33.9764 56.6353,34.0404 C58.2723,33.9154 61.2083,33.4684 64.2553,31.6244 C65.6263,30.7954 70.3873,27.6474 71.9383,21.3404 C73.5033,14.9744 70.6753,9.9564 70.0793,8.9484 C66.8853,12.1484 63.6903,15.3484 60.4963,18.5484 C58.4383,20.2254 55.5363,19.9194 54.0953,18.1804 C52.9483,16.7964 52.8493,14.6544 53.9243,12.9394 C57.2233,9.5644 60.5223,6.1904 63.8223,2.8154 C62.9173,2.2794 57.4913,-0.8166 50.8113,1.1424 C44.6483,2.9494 41.7213,7.7974 40.8983,9.3204 C39.4663,11.9714 39.0553,14.4524 38.9223,15.9604 C38.9113,16.5184 38.8803,17.3044 38.7913,18.2424 C38.7323,18.8774 38.6653,19.5774 38.5443,20.1624 C38.3823,20.9414 37.9863,22.1694 36.8713,23.5704 C30.5803,29.8594 9.39083203,49.9803594 3.09983203,56.2683594 C-0.222167969,59.7763594 -0.190167969,65.2503594 2.95183203,68.5663594 C6.32083203,72.1193594 12.307832,72.1863594 15.902832,68.4433594 C15.902832,68.4433594 37.7353,47.6194 39.5973,45.7504 Z"
            />
            <svg:path
              d="M13.0935008,64.824 C10.8265008,66.275 7.98550079,65.71 6.71250079,63.895 C5.76050079,62.538 5.76450079,60.6 6.71250079,59"
            />
          </svg:g>
        </svg:g>
      </svg:svg>
    </p>
  </div>
  <h1>We can’t process your request.</h1>
  <h3>Don’t worry. It’s probably an easy fix.</h3>
  <p>Try reloading the page in a few minutes.</p>
  <h3>Need help?</h3>
  <p>Visit our <a href="https://support.precisely.com">support</a> area.</p>
  <p-accordion
    class="accordion-noborder"
    expandIcon="png-icon-micro png-arrow2-down"
    collapseIcon="png-icon-micro png-arrow2-up"
  >
    <p-accordionTab header="Click Below for a detailed error message">
      <p class="text-muted mt-4">{{ Error.error.message }}</p>
    </p-accordionTab>
  </p-accordion>
</div>
<div
  *ngIf="Error.error.status === 403"
  aria-label="When HttpError Status code is 403"
  class="my-7 px-4"
  role="main"
>
  <div class="text-center">
    <p class="errors" xmlns:svg="http://www.w3.org/2000/svg">
      <svg:svg
        aria-hidden="true"
        height="136"
        viewBox="0 0 140 136"
        width="140"
        xmlns="http://www.w3.org/2000/svg"
      >
        <svg:g
          class="icon-stroke"
          fill="none"
          fill-rule="evenodd"
          stroke-width="3"
          transform="translate(1 2)"
        >
          <svg:path
            d="M54.6238571,64.1808276 L54.6238571,49.9005517 C54.6238571,42.0473103 60.9996264,35.6202759 68.7935714,35.6202759 L68.7935714,35.6202759 C76.586011,35.6202759 82.9632857,42.0457931 82.9632857,49.9005517 L82.9632857,64.1808276"
          />
          <svg:ellipse cx="68.794" cy="83.221" rx="23.615" ry="23.799" />
          <svg:path
            d="M68.7935714,85.5997241 L68.7935714,92.7398621"
            stroke-linecap="round"
          />
          <svg:ellipse cx="68.794" cy="78.461" rx="7.085" ry="7.14" />
          <svg:path
            d="M.916846154 68.4063448C.916846154 30.6270345 31.3067582 0 68.7935714 0 80.9654945 0 92.3891868 3.22868966 102.268242 8.88344828M43.7361209 132C29.2216484 126.185931 17.1686593 115.471172 9.58698901 101.884276M136.670297 68.4063448C136.670297 97.2066207 119.009341 121.849655 94.0075934 131.937793"
            stroke-linecap="round"
          />
          <svg:path
            d="M42.8855165 20.1307586C50.6568791 15.8536552 59.5709121 13.4215172 69.0495055 13.4215172 91.0733846 13.4215172 110.054659 26.5471724 118.711253 45.4595862M122.017319 82.185931C115.983297 105.997517 94.5570989 123.603586 69.051011 123.603586 38.8613297 123.603586 14.3865055 98.9393103 14.3865055 68.5125517"
            stroke-linecap="round"
          />
        </svg:g>
      </svg:svg>
    </p>
  </div>

  <h1>We can’t let you in.</h1>

  <h3>You’ll need permission first.</h3>
  <p>
    You’ve attempted to access a restricted area that may require special
    permission or a subscription. Contact your administrator with access
    questions.
  </p>
  <p-accordion
    class="accordion-noborder"
    expandIcon="png-icon-micro png-arrow2-down"
    collapseIcon="png-icon-micro png-arrow2-up"
  >
    <p-accordionTab header="Click Below for a detailed error message">
      <p class="text-muted mt-4">{{ Error?.error?.message }}</p>
    </p-accordionTab>
  </p-accordion>
</div>
<div
  *ngIf="Error.error.status === 404"
  aria-label="When HttpError Status code is 404"
  class="my-7 px-4"
  role="main"
>
  <div class="text-center">
    <p class="errors" xmlns:svg="http://www.w3.org/2000/svg">
      <svg:svg
        aria-hidden="true"
        height="136"
        viewBox="0 0 141 136"
        width="141"
        xmlns="http://www.w3.org/2000/svg"
      >
        <svg:g
          fill="none"
          fill-rule="evenodd"
          stroke-width="3"
          transform="translate(2 2)"
        >
          <svg:g class="icon-stroke" stroke-linecap="round">
            <svg:path
              d="M0 68.4063448C0 30.6270345 30.6270345 0 68.4063448 0 80.6732414 0 92.186069 3.22868966 102.142207 8.88344828M43.1533793 132C28.5256552 126.185931 16.3786207 115.471172 8.7377931 101.884276M136.81269 68.4063448C136.81269 97.2066207 119.013931 121.849655 93.8171034 131.937793"
            />
            <svg:path
              d="M42.2961379 20.1307586C50.1281379 15.8536552 59.1117241 13.4215172 68.6642759 13.4215172 90.86 13.4215172 109.989379 26.5471724 118.715034 45.4595862M122.045379 82.185931C115.964276 105.997517 94.3708966 123.603586 68.6642759 123.603586 38.2390345 123.603586 13.5732414 98.9393103 13.5732414 68.5125517"
            />
          </svg:g>
          <svg:g class="icon-stroke" transform="translate(35 32)">
            <svg:path
              d="M47.2484138,33.389931 L65.2626207,51.4041379 C69.3424828,55.484 69.3424828,62.0961379 65.2626207,66.176 L65.2626207,66.176 C61.1827586,70.2558621 54.5706207,70.2558621 50.4907586,66.176 L33.2533793,48.9386207"
            />
            <svg:polyline
              points="30.692 26.682 20.946 16.935 20.92 11.388 10.474 .942 .029 11.388 10.474 21.833 16.021 21.859 25.552 31.39"
              stroke-linejoin="round"
            />
            <svg:path
              d="M46.4852414,47.3986207 L56.3336552,57.2470345"
              stroke-linecap="round"
            />
          </svg:g>
          <svg:g
            class="icon-stroke"
            stroke-linecap="round"
            stroke-linejoin="round"
            transform="translate(33 30)"
          >
            <svg:path
              d="M39.5973,45.7504 C41.1023,44.2404 42.6203,42.7434 44.1203,41.2274 C47.1593,38.1544 48.0683,37.1064 50.0053,35.8374 C50.9053,35.2484 51.8113,34.7534 52.9793,34.4124 C54.4763,33.9774 55.7843,33.9764 56.6353,34.0404 C58.2723,33.9154 61.2083,33.4684 64.2553,31.6244 C65.6263,30.7954 70.3873,27.6474 71.9383,21.3404 C73.5033,14.9744 70.6753,9.9564 70.0793,8.9484 C66.8853,12.1484 63.6903,15.3484 60.4963,18.5484 C58.4383,20.2254 55.5363,19.9194 54.0953,18.1804 C52.9483,16.7964 52.8493,14.6544 53.9243,12.9394 C57.2233,9.5644 60.5223,6.1904 63.8223,2.8154 C62.9173,2.2794 57.4913,-0.8166 50.8113,1.1424 C44.6483,2.9494 41.7213,7.7974 40.8983,9.3204 C39.4663,11.9714 39.0553,14.4524 38.9223,15.9604 C38.9113,16.5184 38.8803,17.3044 38.7913,18.2424 C38.7323,18.8774 38.6653,19.5774 38.5443,20.1624 C38.3823,20.9414 37.9863,22.1694 36.8713,23.5704 C30.5803,29.8594 9.39083203,49.9803594 3.09983203,56.2683594 C-0.222167969,59.7763594 -0.190167969,65.2503594 2.95183203,68.5663594 C6.32083203,72.1193594 12.307832,72.1863594 15.902832,68.4433594 C15.902832,68.4433594 37.7353,47.6194 39.5973,45.7504 Z"
            />
            <svg:path
              d="M13.0935008,64.824 C10.8265008,66.275 7.98550079,65.71 6.71250079,63.895 C5.76050079,62.538 5.76450079,60.6 6.71250079,59"
            />
          </svg:g>
        </svg:g>
      </svg:svg>
    </p>
  </div>
  <h1>That address doesn’t exist.</h1>
  <h3>Here’s what you looked for:</h3>
  <p>You may want to check for typos and try again.</p>
  <p-accordion
    class="accordion-noborder"
    expandIcon="png-icon-micro png-arrow2-down"
    collapseIcon="png-icon-micro png-arrow2-up"
  >
    <p-accordionTab header="Click Below for a detailed error message">
      <p class="text-muted mt-4">{{ Error?.error?.message }}</p>
    </p-accordionTab>
  </p-accordion>
</div>
<div
  *ngIf="Error.error.status === 429"
  aria-label="When HttpError Status code is 429"
  class="my-7 px-4"
  role="main"
>
  <div class="text-center">
    <p class="errors" xmlns:svg="http://www.w3.org/2000/svg">
      <svg:svg
        aria-hidden="true"
        height="136"
        viewBox="0 0 139 136"
        width="139"
        xmlns="http://www.w3.org/2000/svg"
      >
        <svg:g
          fill="none"
          fill-rule="evenodd"
          stroke-width="3"
          transform="translate(1 2)"
        >
          <svg:path
            class="icon-stroke"
            d="M.632307692 68.4063448C.632307692 30.6270345 31.0222198 0 68.509033 0 80.680956 0 92.1046484 3.22868966 101.983703 8.88344828M43.4515824 132C28.9371099 126.185931 16.8841209 115.471172 9.30245055 101.884276M136.384253 68.4063448C136.384253 97.2066207 118.723297 121.849655 93.7215495 131.937793"
            stroke-linecap="round"
          />
          <svg:path
            class="icon-stroke"
            d="M42.600978 20.1307586C50.3723407 15.8536552 59.2863736 13.4215172 68.764967 13.4215172 90.7888462 13.4215172 109.770121 26.5471724 118.42822 45.4595862M121.731275 82.185931C115.697253 105.997517 94.2710549 123.603586 68.7634615 123.603586 38.5737802 123.603586 14.098956 98.9393103 14.098956 68.5125517"
            stroke-linecap="round"
          />
          <svg:g class="icon-stroke" transform="translate(59.22 30.345)">
            <svg:polygon
              points="-12.549 13.655 32.615 13.655 32.615 31.862 -12.549 31.862"
              stroke-linecap="round"
              stroke-linejoin="round"
              transform="rotate(-90 10.033 22.759)"
            />
            <svg:ellipse cx="10.033" cy="62.207" rx="9.033" ry="9.103" />
          </svg:g>
        </svg:g>
      </svg:svg>
    </p>
  </div>

  <h1>Give us a moment to catch up.</h1>
  <h3>Our server is getting more requests from you than it can handle.</h3>
  <p>
    We've received too many requests from you or your app. Wait a few minutes
    and try again.
  </p>

  <p-accordion
    class="accordion-noborder"
    expandIcon="png-icon-micro png-arrow2-down"
    collapseIcon="png-icon-micro png-arrow2-up"
  >
    <p-accordionTab header="Click Below for a detailed error message">
      <p class="text-muted mt-4">{{ Error?.error?.message }}</p>
    </p-accordionTab>
  </p-accordion>
</div>
<div
  *ngIf="Error.error.status === 500 || Error.error.status === 200"
  aria-label="When HttpError Status code is 500 or 200"
  class="my-7 px-4"
  role="main"
>
  <div class="text-center">
    <p class="errors" xmlns:svg="http://www.w3.org/2000/svg">
      <svg:svg
        aria-hidden="true"
        height="136"
        viewBox="0 0 139 136"
        width="139"
        xmlns="http://www.w3.org/2000/svg"
      >
        <svg:g
          fill="none"
          fill-rule="evenodd"
          stroke-width="3"
          transform="translate(1 2)"
        >
          <svg:path
            class="icon-stroke"
            d="M.632307692 68.4063448C.632307692 30.6270345 31.0222198 0 68.509033 0 80.680956 0 92.1046484 3.22868966 101.983703 8.88344828M43.4515824 132C28.9371099 126.185931 16.8841209 115.471172 9.30245055 101.884276M136.384253 68.4063448C136.384253 97.2066207 118.723297 121.849655 93.7215495 131.937793"
            stroke-linecap="round"
          />
          <svg:path
            class="icon-stroke"
            d="M42.600978 20.1307586C50.3723407 15.8536552 59.2863736 13.4215172 68.764967 13.4215172 90.7888462 13.4215172 109.770121 26.5471724 118.42822 45.4595862M121.731275 82.185931C115.697253 105.997517 94.2710549 123.603586 68.7634615 123.603586 38.5737802 123.603586 14.098956 98.9393103 14.098956 68.5125517"
            stroke-linecap="round"
          />
          <svg:g class="icon-stroke" transform="translate(59.22 30.345)">
            <svg:polygon
              points="-12.549 13.655 32.615 13.655 32.615 31.862 -12.549 31.862"
              stroke-linecap="round"
              stroke-linejoin="round"
              transform="rotate(-90 10.033 22.759)"
            />
            <svg:ellipse cx="10.033" cy="62.207" rx="9.033" ry="9.103" />
          </svg:g>
        </svg:g>
      </svg:svg>
    </p>
  </div>
  <h1>Seems like an internal server issue.</h1>
  <h3>We’re working on it.</h3>
  <p>In the meantime, you can try reloading the page.</p>
  <p-accordion
    class="accordion-noborder"
    expandIcon="png-icon-micro png-arrow2-down"
    collapseIcon="png-icon-micro png-arrow2-up"
  >
    <p-accordionTab header="Click Below for a detailed error message">
      <p class="text-muted mt-4">{{ Error?.error?.message }}</p>
    </p-accordionTab>
  </p-accordion>
</div>
<div
  *ngIf="Error.error.status === 502"
  aria-label="When HttpError Status code is 502"
  class="my-7 px-4"
  role="main"
>
  <div class="text-center">
    <p class="errors" xmlns:svg="http://www.w3.org/2000/svg">
      <svg:svg
        aria-hidden="true"
        height="136"
        viewBox="0 0 139 136"
        width="139"
        xmlns="http://www.w3.org/2000/svg"
      >
        <svg:g
          fill="none"
          fill-rule="evenodd"
          stroke-width="3"
          transform="translate(1 2)"
        >
          <svg:path
            class="icon-stroke"
            d="M.632307692 68.4063448C.632307692 30.6270345 31.0222198 0 68.509033 0 80.680956 0 92.1046484 3.22868966 101.983703 8.88344828M43.4515824 132C28.9371099 126.185931 16.8841209 115.471172 9.30245055 101.884276M136.384253 68.4063448C136.384253 97.2066207 118.723297 121.849655 93.7215495 131.937793"
            stroke-linecap="round"
          />
          <svg:path
            class="icon-stroke"
            d="M42.600978 20.1307586C50.3723407 15.8536552 59.2863736 13.4215172 68.764967 13.4215172 90.7888462 13.4215172 109.770121 26.5471724 118.42822 45.4595862M121.731275 82.185931C115.697253 105.997517 94.2710549 123.603586 68.7634615 123.603586 38.5737802 123.603586 14.098956 98.9393103 14.098956 68.5125517"
            stroke-linecap="round"
          />
          <svg:g class="icon-stroke" transform="translate(59.22 30.345)">
            <svg:polygon
              points="-12.549 13.655 32.615 13.655 32.615 31.862 -12.549 31.862"
              stroke-linecap="round"
              stroke-linejoin="round"
              transform="rotate(-90 10.033 22.759)"
            />
            <svg:ellipse cx="10.033" cy="62.207" rx="9.033" ry="9.103" />
          </svg:g>
        </svg:g>
      </svg:svg>
    </p>
  </div>

  <h1>We’re having an issue with our server.</h1>
  <h3>There’s a good chance it’s a problem on our end.</h3>
  <p>Here are some things to try:</p>
  <ul>
    <li>Wait a few minutes and try reloading the page.</li>
    <li>Clear your browser’s cache, delete cookies and then try again.</li>
    <li>Try loading the page in a different browser.</li>
    <li>
      If you’re connecting with a proxy, check with your network administrator.
    </li>
  </ul>
  <p-accordion
    class="accordion-noborder"
    expandIcon="png-icon-micro png-arrow2-down"
    collapseIcon="png-icon-micro png-arrow2-up"
  >
    <p-accordionTab header="Click Below for a detailed error message">
      <p class="text-muted mt-4">{{ Error?.error?.message }}</p>
    </p-accordionTab>
  </p-accordion>
</div>
<div
  *ngIf="Error.error.status === 503"
  aria-label="When HttpError Status code is 503"
  class="my-7 px-4"
  role="main"
>
  <div class="text-center">
    <p class="errors" xmlns:svg="http://www.w3.org/2000/svg">
      <svg:svg
        aria-hidden="true"
        height="136"
        viewBox="0 0 139 136"
        width="139"
        xmlns="http://www.w3.org/2000/svg"
      >
        <svg:g
          fill="none"
          fill-rule="evenodd"
          stroke-width="3"
          transform="translate(1 2)"
        >
          <svg:path
            class="icon-stroke"
            d="M.632307692 68.4063448C.632307692 30.6270345 31.0222198 0 68.509033 0 80.680956 0 92.1046484 3.22868966 101.983703 8.88344828M43.4515824 132C28.9371099 126.185931 16.8841209 115.471172 9.30245055 101.884276M136.384253 68.4063448C136.384253 97.2066207 118.723297 121.849655 93.7215495 131.937793"
            stroke-linecap="round"
          />
          <svg:path
            class="icon-stroke"
            d="M42.600978 20.1307586C50.3723407 15.8536552 59.2863736 13.4215172 68.764967 13.4215172 90.7888462 13.4215172 109.770121 26.5471724 118.42822 45.4595862M121.731275 82.185931C115.697253 105.997517 94.2710549 123.603586 68.7634615 123.603586 38.5737802 123.603586 14.098956 98.9393103 14.098956 68.5125517"
            stroke-linecap="round"
          />
          <svg:g class="icon-stroke" transform="translate(59.22 30.345)">
            <svg:polygon
              points="-12.549 13.655 32.615 13.655 32.615 31.862 -12.549 31.862"
              stroke-linecap="round"
              stroke-linejoin="round"
              transform="rotate(-90 10.033 22.759)"
            />
            <svg:ellipse cx="10.033" cy="62.207" rx="9.033" ry="9.103" />
          </svg:g>
        </svg:g>
      </svg:svg>
    </p>
  </div>

  <h1>Our server’s too busy to handle your request.</h1>
  <h3>There’s a good chance it’s a problem on our end.</h3>
  <p>
    We're experiencing a temporary outage. Wait a few minutes and try reloading
    the page. And thanks for your patience.
  </p>
  <p-accordion
    class="accordion-noborder"
    expandIcon="png-icon-micro png-arrow2-down"
    collapseIcon="png-icon-micro png-arrow2-up"
  >
    <p-accordionTab header="Click Below for a detailed error message">
      <p class="text-muted mt-4">{{ Error?.error?.message }}</p>
    </p-accordionTab>
  </p-accordion>
</div>
<div
  *ngIf="Error.error.status === 504"
  aria-label="When HttpError Status code is 504"
  class="my-7 px-4"
  role="main"
>
  <div class="text-center">
    <p class="errors" xmlns:svg="http://www.w3.org/2000/svg">
      <svg:svg
        aria-hidden="true"
        height="136"
        viewBox="0 0 139 136"
        width="139"
        xmlns="http://www.w3.org/2000/svg"
      >
        <svg:g
          fill="none"
          fill-rule="evenodd"
          stroke-width="3"
          transform="translate(1 2)"
        >
          <svg:path
            class="icon-stroke"
            d="M.632307692 68.4063448C.632307692 30.6270345 31.0222198 0 68.509033 0 80.680956 0 92.1046484 3.22868966 101.983703 8.88344828M43.4515824 132C28.9371099 126.185931 16.8841209 115.471172 9.30245055 101.884276M136.384253 68.4063448C136.384253 97.2066207 118.723297 121.849655 93.7215495 131.937793"
            stroke-linecap="round"
          />
          <svg:path
            class="icon-stroke"
            d="M42.600978 20.1307586C50.3723407 15.8536552 59.2863736 13.4215172 68.764967 13.4215172 90.7888462 13.4215172 109.770121 26.5471724 118.42822 45.4595862M121.731275 82.185931C115.697253 105.997517 94.2710549 123.603586 68.7634615 123.603586 38.5737802 123.603586 14.098956 98.9393103 14.098956 68.5125517"
            stroke-linecap="round"
          />
          <svg:g class="icon-stroke" transform="translate(59.22 30.345)">
            <svg:polygon
              points="-12.549 13.655 32.615 13.655 32.615 31.862 -12.549 31.862"
              stroke-linecap="round"
              stroke-linejoin="round"
              transform="rotate(-90 10.033 22.759)"
            />
            <svg:ellipse cx="10.033" cy="62.207" rx="9.033" ry="9.103" />
          </svg:g>
        </svg:g>
      </svg:svg>
    </p>
  </div>

  <h1>Let’s try that again.</h1>
  <h3>It took too long to process your request.</h3>
  <p>Here’s what you can do next:</p>
  <ul>
    <li>Wait a few minutes and try reloading the page.</li>
    <li>Clear your browser’s cache, delete cookies and then try again.</li>
    <li>Try loading the page in a different browser.</li>
    <li>
      If you’re connecting with a proxy, check with your network administrator.
    </li>
  </ul>
  <p-accordion
    class="accordion-noborder"
    expandIcon="png-icon-micro png-arrow2-down"
    collapseIcon="png-icon-micro png-arrow2-up"
  >
    <p-accordionTab header="Click Below for a detailed error message">
      <p class="text-muted mt-4">{{ Error?.error?.message }}</p>
    </p-accordionTab>
  </p-accordion>
</div>
